// extracted by mini-css-extract-plugin
module.exports = {"root":"PlayButton_root_3f_-x","root-township":"PlayButton_root-township_2keTW","root-homescapes":"PlayButton_root-homescapes_q5UTM"};